import Button from "../CustomButton/CustomButton";
import { FormattedMessage } from "react-intl";
import React from "react";

const button = props => (
  <Button {...props} icon wd bsStyle="primary">
    <i className="fa fa-lg fa-plus-circle margin-right-5" />
    <FormattedMessage id="ids_addBank" />
  </Button>
);

export default button;
